// extracted by mini-css-extract-plugin
module.exports = {"bubbleMenu":"InlineMenu_bubbleMenu__3inA_","hidden":"InlineMenu_hidden__lnCEd"};